export default __webpack_public_path__ + "static/media/facct22-slides.7dccaab1.pdf";